
export class WpEtEnrollment {
    constructor(
        public id?: number,
        public referredDt?: any,
        public enrollmentStartDt?: any,
        public enrollmentEndDt?: any,
        public orientationDt?: any,
        public assessmentDt?: any,
        public etRegInd?: string,
        public activityTypeCd?: string,
        public wpPerson?: any,
        public wpReferral?: any,
        public programCd?: string,
        public assignedProvider?: string,
        public closureReasonCd?: string,
        public reActivateReasonCd?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-et-enrollment.model.ts